import { windowHelper } from '@tencent/ppd-base-libs';
import { userEnv } from '@tencent/wphk-base-utils';
import dayjs from 'dayjs';

/** 判断页面打开环境 */
export const isInWeixin = userEnv.isInWeixin;

/** 跳转引导下载微信 */
export function goDownloadWx() {
  windowHelper.redirect('https://www.wechat.com/mobile/en/', 200);
}

/** 端外拉起小程序并打开指定url，小程序schema带参数：url=base64(H5_url) */
export function openMiniProgam(urlSchema: string) {
  windowHelper.redirect(urlSchema, 200);
}

export function formatTimeToChinese(time: string) {
  return dayjs(time).format('YYYY年M月D日');
}
